export default __webpack_public_path__ + "static/media/contentIconDisabled.6ccb66dc.svg";